// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14MfU","clinicsSelect":"styles_clinicsSelect__1h709"};